/**
 * Toast Context Hook
 *
 * Simple wrapper around toast utility for backward compatibility.
 * This is a standalone file to avoid barrel export issues.
 */

import { toast as toastUtil } from "@/services/shared/utils/toast";

/**
 * Stable singleton — components put this in useEffect deps, so it must keep
 * the same identity across renders or every consumer re-runs its effects
 * (this previously caused infinite request loops, e.g. AI Assistant 429s).
 */
const stableToast = {
  success: (message: string, duration?: number) => {
    toastUtil.success(message, duration);
  },
  error: (message: string, duration?: number) => {
    toastUtil.error(message, duration);
  },
  info: (message: string, duration?: number) => {
    toastUtil.info(message, duration);
  },
  warning: (message: string, duration?: number) => {
    toastUtil.warning(message, duration);
  },
};

/**
 * Compatibility hook for useToastContext
 *
 * ✅ This file is standalone - importing from here doesn't pull in other contexts
 */
export function useToastContext() {
  return stableToast;
}
